import * as React from "react";
const SvgFiRrCheckDouble = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-check-double_svg__a)">
      <path
        fill="#062147"
        d="M1.283 7.697a1 1 0 1 1 1.435-1.393l4.089 4.211c.307.31.729.485 1.176.486.445 0 .864-.173 1.179-.488l9.128-9.217a1 1 0 0 1 1.414-.007 1 1 0 0 1 .007 1.414l-9.131 9.219A3.66 3.66 0 0 1 7.976 13a3.64 3.64 0 0 1-2.596-1.085zm22.423-.405a1 1 0 0 0-1.414.002L9.205 20.414a1.996 1.996 0 0 1-2.841-.013l-4.665-4.617a1 1 0 0 0-1.408 1.422l4.659 4.61A3.98 3.98 0 0 0 7.783 23a4 4 0 0 0 2.837-1.173L23.708 8.706a1 1 0 0 0-.002-1.414"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-check-double_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCheckDouble;
